import React from "react";
import propTypes from "prop-types";
import { Container } from "react-bootstrap";
import MainOrgDetailsComponent from "components/ClinksOrgDetails/MainOrgDetailsComponent";
const ClinksOrgDetails = (props) => {
  return (
    <section className="orgd__section">
      <Container fluid="fluid">
        <MainOrgDetailsComponent {...props} />
      </Container>
    </section>
  );
};
ClinksOrgDetails.propTypes = {
  history: propTypes.object,
};
export default ClinksOrgDetails;
